import { ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-village-modal',
  templateUrl: './create-village-modal.page.html',
  styleUrls: ['./create-village-modal.page.scss'],
})
export class CreateVillageModalPage implements OnInit {

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {
  }

  goBack() {
    this.modalCtrl.dismiss();
  }

}
